var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{staticClass:"c-checkout-button",class:{
    'c-checkout-button--loading': _vm.loading,
  },attrs:{"button-size":['large', 'thin'],"is-disabled":_vm.loading,"type":_vm.buttonType},on:{"click":_vm.checkout}},[_c('span',{staticClass:"c-checkout-button__text"},[_vm._v(" "+_vm._s(_vm.checkoutText)+" now")])])
}
var staticRenderFns = []

export { render, staticRenderFns }